import { isAnalyticsEnabled, posthog } from './posthog';
import type { AnalyticsSink } from './sinks';

/**
 * The original `track()` body, unchanged, behind the sink interface.
 *
 * Note what is NOT here: context enrichment. That stays in
 * `posthog.init({ before_send })` (see ./posthog) because it is the only hook
 * that also catches the SDK's automatic `$pageview`. Hoisting it up into
 * `track()` would silently strip org/brand/page context from every pageview.
 */
export const posthogSink: AnalyticsSink = {
  name: 'posthog',

  // Was the `if (!isAnalyticsEnabled) return` guard at the top of `track()`.
  // It belongs here, not in the dispatcher: the flag means "PostHog is
  // configured", and leaving it upstream would have made every other sink dead
  // whenever the PostHog env vars happened to be unset.
  isEnabled: () => isAnalyticsEnabled,

  capture: (event, properties, options) => {
    posthog.capture(
      event,
      properties,
      options?.beforeNavigation
        ? { send_instantly: true, transport: 'sendBeacon' }
        : undefined
    );
  }
};
